import { AdminRole } from "@/types";
import { ResourceName } from "./react-admin.util";

export type PermissionAction = "create" | "edit" | "delete" | "view" | "*";
export type PermissionResource = ResourceName;

type PermissionMatrix = {
  [role in AdminRole]: {
    [resource in PermissionResource]: PermissionAction[];
  };
};

/**
 * Permissions components
 * Every action in resource should be defined explicitly
 */
export const permissionsMatrix: PermissionMatrix = {
  [AdminRole.SUPER_ADMIN]: {
    "admin-users": ["*"],
    users: ["*"],
    "vetting-users": ["*"],
    "affiliate-users": ["*"],
    "referral-users": ["*"],
    "affiliate-payouts": ["*"],
    "user-purchases": ["*"],
    "users-analytics": ["*"],
    support: ["*"],
    events: ["*"],
  },
  [AdminRole.ADMIN]: {
    "admin-users": [],
    users: ["*"],
    "vetting-users": ["*"],
    "affiliate-users": ["*"],
    "referral-users": ["*"],
    "affiliate-payouts": ["*"],
    "user-purchases": ["*"],
    "users-analytics": ["*"],
    support: ["*"],
    events: ["*"],
  },
  [AdminRole.VETTING_ADMIN]: {
    "admin-users": [],
    users: [],
    "vetting-users": ["*"],
    "affiliate-users": [],
    "referral-users": ["*"],
    "affiliate-payouts": ["*"],
    "user-purchases": [],
    "users-analytics": [],
    support: [],
    events: ["*"],
  },
};

export type RaAction =
  | "custom-page" // custom value
  | "list"
  | "show"
  | "create"
  | "edit"
  | "delete"
  | "export"
  | "clone"
  | "read"
  | "write";

type RoutingPermissionMatrix = {
  [role in AdminRole]?: {
    [resource in ResourceName]?: {
      [action in RaAction]?: boolean;
    };
  };
};
/**
 * Permissions for page routing
 * By default everything is "true"
 */
export const routingPermissionsMatrix: RoutingPermissionMatrix = {
  [AdminRole.SUPER_ADMIN]: {},
  [AdminRole.ADMIN]: {
    [ResourceName.ADMIN_USERS]: {
      list: false,
    },
  },
  [AdminRole.VETTING_ADMIN]: {
    [ResourceName.ADMIN_USERS]: {
      list: false,
    },
    [ResourceName.USERS]: {
      list: false,
    },
    [ResourceName.AFFILIATE_USERS]: {
      list: false,
    },
    [ResourceName.REFERRAL_USERS]: {
      list: false,
    },
    [ResourceName.EVENTS]: {
      list: false,
    },
    [ResourceName.AFFILIATE_PAYOUTS]: {
      list: false,
    },
    [ResourceName.SUPPORT]: {
      "custom-page": false,
    },
    [ResourceName.USERS_ANALYTICS]: {
      "custom-page": false,
    },
  },
};
